<template>
  <td>
    <button type="button" :class="buttonClass" @click="$emit('clicked')">{{ name }}</button>
  </td>
</template>

<script setup lang="ts">
const props = defineProps({
  name: { type: String, required: true },
  //placeholder: { type: String },
  //disabled: { type: Boolean },
  // readonly: { type: Boolean },
  buttonClass: { type: String }
  // type: { type: String }
})

const emits = defineEmits(['clicked'])
</script>

<style lang="css" scoped>
button {
  width: 100%;
  height: 2rem;
  border: none;
  outline: none;
  padding-left: 0.25rem;
  /*font-size:large;*/
}
td {
  padding: 0;
  margin: 0;
}
.yellow {
  background-color: yellow;
  color: black;
}
</style>
